import { gettext } from '@eventbrite/i18n';

export const PAYMENT_OPTIONS = [
    {
        value: 'check',
        display: gettext('Paid with check'),
    },
    {
        value: 'cash',
        display: gettext('Paid with cash'),
    },
    {
        value: 'paypal',
        display: gettext('Paid directly online with PayPal'),
    },
    {
        value: 'online',
        display: gettext('Paid online non-PayPal'),
    },
    {
        value: 'comp',
        display: gettext('Complimentary'),
    },
    {
        value: 'free',
        display: gettext('No payment necessary'),
    },
    {
        value: 'voucher',
        display: gettext('Paid With Voucher'),
    },
    {
        value: 'credit',
        display: gettext('Paid Directly By Credit Card'),
    },
    {
        value: 'debit',
        display: gettext('Paid Directly By Debit Card'),
    },
    {
        value: 'other',
        display: gettext('Other'),
    },
];

export const INSTRUMENT_TYPE_MANUAL = 'MANUAL';
